export default __webpack_public_path__ + "static/media/logo-card-2048w.27750161.png";